export default __webpack_public_path__ + "static/media/Refinishing.b267efe8.jpg";